<template>
  <div>
    <rich-radio-group
      :options="cityData"
      position="right"
      :value="areaCityChecked.value"
      @input="cityChange"
    />
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  components: {},
  name: 'cityPopup',
  props: {
    cityData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('bizoppV2', ['areaCityChecked'])
  },
  methods: {
    ...mapMutations('bizoppV2', ['updateAreaCityChecked']),
    cityChange(val) {
      if (val) {
        this.$emit('cityChange', val)
        this.updateAreaCityChecked({
          // label: this.cityData.find((item) => item.value === val).label,
          value: val
        })
      }
    }
  }
}
</script>
